import styled from "styled-components";
import { Tag, Shield, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Container } from "../layout/Container";

const Section = styled.section`
  background: hsl(${({ theme }) => theme.colors.navDark});
  padding: 4rem 0;
`;

const Inner = styled.div`
  text-align: center;
`;

const H1 = styled.h1`
  font-size: ${({ theme }) => theme.font.heroTitle};
  font-weight: 800;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
  margin: 0 0 1rem;
`;

const Accent = styled.span`
  color: hsl(${({ theme }) => theme.colors.accent});
`;

const Lead = styled.p`
  font-size: clamp(1.0625rem, 0.95rem + 0.45vw, 1.375rem);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.6);
  margin: 0 auto 2rem;
  max-width: min(100%, 56rem);
`;

const Perks = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1.0625rem);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.7);
`;

const Perk = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export default function HomeHero() {
  const { t } = useTranslation();

  return (
    <Section>
      <Container>
        <Inner>
          <H1>
            {t("home.hero.saveMore")} <Accent>{t("home.hero.todaysBest")}</Accent> {t("home.hero.coupons")}
          </H1>
          <Lead>{t("home.hero.tagline")}</Lead>
          <Perks>
            <Perk>
              <Tag size={16} strokeWidth={2} color="hsl(43 80% 52%)" />
              {t("home.hero.stat1")}
            </Perk>
            <Perk>
              <Shield size={16} strokeWidth={2} color="hsl(43 80% 52%)" />
              {t("home.hero.stat2")}
            </Perk>
            <Perk>
              <Clock size={16} strokeWidth={2} color="hsl(43 80% 52%)" />
              {t("home.hero.stat3")}
            </Perk>
          </Perks>
        </Inner>
      </Container>
    </Section>
  );
}
